import { FC } from 'react';
import { Space } from 'antd';
interface Props {
  title: string;
  isOpen: boolean;
  onClick?: () => void;
}
const HeaderArrowMenu: FC<Props> = ({
  title,
  isOpen,
  onClick
}: Props) => {
  return <Space direction="horizontal" onClick={onClick}>
            <div>{title}</div>
            <div>
                <svg style={isOpen ? {
        transform: 'rotate(-180deg)',
        transition: 'all .3s'
      } : {
        transform: 'rotate(0deg)',
        transition: 'all .3s'
      }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path d="M3.3332 7.5L8.76654 12.9333C9.4082 13.575 10.4582 13.575 11.0999 12.9333L16.5332 7.5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </Space>;
};
export default HeaderArrowMenu;